import { render, staticRenderFns } from "./StartView.vue?vue&type=template&id=5a8c7e6e&scoped=true&"
import script from "./StartView.vue?vue&type=script&lang=js&"
export * from "./StartView.vue?vue&type=script&lang=js&"
import style0 from "./StartView.vue?vue&type=style&index=0&id=5a8c7e6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8c7e6e",
  null
  
)

export default component.exports